"use strict";

var _defineProperty = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/defineProperty.js");

var _exports$withTranslat;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTranslation = void 0;

var Menu_models_1 = require("./Menu.models");

exports.withTranslation = (_exports$withTranslat = {}, _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.creditApplication, {
  en: "Credit Application",
  fr: "Demande de crédit",
  es: "Solicitud de crédito"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.dashboard, {
  en: "Dashboard",
  fr: "Tableau de bord",
  es: "Tablero"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.orders, {
  en: "Orders",
  fr: "Ordres",
  es: "Pedidos"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.subscribeSave, {
  en: "Subscribe & Save",
  fr: "Abonnez-vous et économisez",
  es: "Suscribirse y Guardar"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.shoppingList, {
  en: "Shopping Lists",
  fr: "Liste de courses",
  es: "Lista de la compra"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.quotes, {
  en: "Quotes",
  fr: "Devis",
  es: "Citas"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.invoices, {
  en: "Invoices",
  fr: "Factures",
  es: "Facturas"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.myResources, {
  en: "My Resources",
  fr: "Mes ressources",
  es: "Mis Recursos"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.claimsReturns, {
  en: "Claims & Returns",
  fr: "Réclamations et retours",
  es: "Reclamaciones y devoluciones"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.reports, {
  en: "Reports",
  fr: "Rapports",
  es: "Informes"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.accountSettings, {
  en: "Account Settings",
  fr: "Paramètres du compte",
  es: "Configuraciones de la cuenta"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.preferenceSettings, {
  en: "Preferences & Settings",
  fr: "Préférences et paramètres",
  es: "Preferencias y configuraciones"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.userManagement, {
  en: "User Management",
  fr: "Gestion des utilisateurs",
  es: "Gestión de usuarios"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.switchAccounts, {
  en: "Switch Accounts",
  fr: "Changer de compte",
  es: "Cambiar cuentas"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.logOut, {
  en: "Log Out",
  fr: "Se déconnecter",
  es: "Cerrar sesión"
}), _defineProperty(_exports$withTranslat, "more-button", {
  en: "More",
  fr: "Suite",
  es: "Más"
}), _defineProperty(_exports$withTranslat, "Your Account", {
  en: "Your Account",
  fr: "Votre compte",
  es: "Su cuenta"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.adminPortal, {
  en: "Admin Portal",
  fr: "portail d'admin",
  es: "portal de admin"
}), _defineProperty(_exports$withTranslat, Menu_models_1.AccountMenuItemId.exitShadowMode, {
  en: "Return to Normal",
  fr: "Retour à la normale",
  es: "Regresar a la normalidad"
}), _exports$withTranslat);